import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageKeys } from '@core/constants/constants';
import { UserInfoService } from '@core/services/user-info.service';
import {LoadingService} from '@shared/services/loading.service';

/** Root real, también con query (`/?ch_provider=o2`). `state.url` incluye search. */
function isAppRootUrl(url: string): boolean {
	const path = url.split('?')[0];
	return path === '/' || path === '';
}

export const AuthGuard: CanActivateFn = (route, state) => {
	const router = inject(Router);
	const userInfoService = inject(UserInfoService);
	const loadingService = inject(LoadingService);

	const accessToken = localStorage.getItem(StorageKeys.ACCESS_TOKEN);
	if (!accessToken) {
		loadingService.hide();
		loadingService.hideMaster();
		router.navigate(['login']);
		return false;
	}

	// Root path: redirect to back/front based on role
	if (isAppRootUrl(state.url)) {
		if (userInfoService.user()?.user?.role) {
			userInfoService.redirectUser();
		} else {
			userInfoService.setUserInfo();
		}
		return false;
	}

	return true;
};
